import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import { Row, Col } from 'react-bootstrap';
import API from '../Utils/Api';


function FooterAfterLogin(props) {
    const [inputs, setInputs] = useState({facebook:'',youtube:'',instagram:''});

    useEffect(() => {            
            API.post('get_settings')
                .then(response => {
                    
                    if (response.data.status === false) {

                    } else {
                        setInputs({
                            facebook:response.data.data.facebook,
                            youtube:response.data.data.youtube,
                            instagram:response.data.data.instagram
                        });
                    }
                }).catch(error => {
                    
                });
        }, []);
    return (
        <>
            <Row>
                <Col md={3} sm={6} xs={6}>
                    <h4>General</h4>
                    <ul>
                        <li>
                            <Link to="/neighbour/privacy">Privacy Policy</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/terms">Terms and Conditions</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/customer-support">Customer Support</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/press">Press</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/contact-us">Contact Us</Link>
                        </li>
                    </ul>
                </Col>
                <Col md={3} sm={6} xs={6}>
                    <h4>Know More</h4>
                    <ul>
                        <li>
                            <Link to="/neighbour/about">About LocalBells</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/how-it-works">How It Works</Link>
                        </li>
                        {/*<li>
                            <Link to="">Blogs</Link>
                        </li>*/}
                        <li>
                            <Link to="/neighbour/help-center">FAQ</Link>
                        </li>
                    </ul>
                </Col>
                <Col md={3} sm={6} xs={6}>
                    <h4>Local Business</h4>
                    <ul>
                        <li>
                            <Link to="/neighbour/advertisement">Advertisement on LocalBells</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/register-business">Register Business on LoccalBells</Link>
                        </li>
                    </ul>
                </Col>
                <Col md={3} sm={6} xs={6}>
                    <h4>Join us</h4>
                    <ul>
                        <li>
                            <Link to="/neighbour/affiliate-partnership">Affiliate Partnership</Link>
                        </li>
                        <li>
                            <Link to="/neighbour/career">Career</Link>
                        </li>
                    </ul>
                </Col>
            </Row>
            <Row className='footer-bot'>
                <Col xs={6} sm={6}>
                    <p>© 2025 LocalBells. All rights reserved.</p>
                </Col>
                <Col xs={6} sm={6}>
                    <div>
                        <Link to={inputs.facebook}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/fb.webp'} className="img-fluid" alt="fb" /></Link>
                        <Link to={inputs.instagram}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/insta.webp'} className="img-fluid" alt="insta" /></Link>
                        <Link to={inputs.youtube}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/youtube.webp'} className="img-fluid" alt="youtube" /></Link>
                    </div>
                </Col>
            </Row>
        </>
    );
}
export default FooterAfterLogin;